// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyDXCK3DPxNjaNctUhDAluQ4m7Z125yI694",
  authDomain: "rippl-staging.firebaseapp.com",
  projectId: "rippl-staging",
  storageBucket: "rippl-staging.appspot.com",
  messagingSenderId: "396750011783",
  appId: "1:396750011783:web:ef602de23510df9baa6722",
  measurementId: "G-TKPR6D52NM"
};